import { render, staticRenderFns } from "./PlannerKanban.vue?vue&type=template&id=2c64b154&scoped=true&"
import script from "./PlannerKanban.vue?vue&type=script&lang=js&"
export * from "./PlannerKanban.vue?vue&type=script&lang=js&"
import style0 from "./PlannerKanban.vue?vue&type=style&index=0&id=2c64b154&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c64b154",
  null
  
)

export default component.exports